import * as React from 'react';

import {Button} from 'shells/button/button';

import type {Option} from '../../../core/select/graphql-select-inline';

import {AttendeeToContactCreatePopover} from './attendee-to-contact-create-popover';
import type {ExternalAttendeeToContactData} from './participants-section';

import styles from './calendar.module.css';

type Props = {
    option: Option;
    handleCreateContactFromExternalAttendee: (data: ExternalAttendeeToContactData) => void;
    isCreatingOrMergingContact: boolean;
};

const CLOSE_OTHER_MODALS_EVENT = 'closeOtherAttendeeModals';

export function AttendeeAddButton(props: Props) {
    const [isModalOpen, setIsModalOpen] = React.useState<boolean>(false);
    const bttnRef = React.useRef<HTMLButtonElement | null | undefined>(null);

    // Listen for events from other instances to close this modal
    React.useEffect(() => {
        const handleCloseOtherModals = (event: CustomEvent) => {
            if (event.detail.triggerId !== props.option.id) {
                setIsModalOpen(false);
            }
        };

        // @ts-expect-error
        window.addEventListener(CLOSE_OTHER_MODALS_EVENT, handleCloseOtherModals);

        return () => {
            // @ts-expect-error
            window.removeEventListener(CLOSE_OTHER_MODALS_EVENT, handleCloseOtherModals);
        };
    }, [props.option.id]);

    const handleClick = () => {
        window.dispatchEvent(
            new CustomEvent(CLOSE_OTHER_MODALS_EVENT, {
                detail: {triggerId: props.option.id},
            })
        );

        setIsModalOpen(true);
    };

    return (
        <div
            key={`add-to-nutshell-button-container-${props.option.id}`}
            className={styles['add-to-nutshell-button-container']}
        >
            <Button
                variant='text-primary'
                size='small'
                onClick={handleClick}
                getButtonRef={bttnRef}
            >
                + Add to Nutshell
            </Button>
            {isModalOpen && (
                <AttendeeToContactCreatePopover
                    anchor={bttnRef.current}
                    onClose={() => setIsModalOpen(false)}
                    onSubmit={props.handleCreateContactFromExternalAttendee}
                    data={{
                        name: props.option.name,
                        email: props.option.emailAddress,
                        phone: props.option.primaryInfo,
                        externalAttendeeId: props.option.id,
                    }}
                    isSubmitting={props.isCreatingOrMergingContact}
                />
            )}
        </div>
    );
}
